import * as React from "react";
const CaretUpDownIcon = ({
  size = 16,
  title = "CaretUpDownIcon",
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pds-icon", title, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.046 9h3.908c.485 0 .729.675.385 1.07l-1.954 2.246A.511.511 0 0 1 8 12.5a.512.512 0 0 1-.385-.184L5.66 10.07C5.317 9.675 5.56 9 6.046 9ZM9.954 7H6.046c-.485 0-.729-.675-.385-1.07l1.954-2.247A.512.512 0 0 1 8 3.5c.144 0 .283.066.385.183L10.34 5.93c.344.395.1 1.07-.385 1.07Z", fill: "currentColor" }));
export default CaretUpDownIcon;
